module.exports = __webpack_public_path__ + "img/account-icon.54e0d3e5.svg";